// extracted by mini-css-extract-plugin
export default {"container":"styles_container__51tWf","noAlt":"styles_noAlt__UfwV+","icon":"styles_icon__efq00","title":"styles_title__mMKTE","subsection":"styles_subsection__OoyOY"};